import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";

/**
 * smooth scroll
 *
 * @param {Integer} buffer: スクロール完了位置の上部の余白
 * @param {Integer} [duration = 600]: アニメーション時間
 * @param {Function} [callback]: 完了コールバック
 * @returns
 */
$.fn.attachSmoothScroll = function attachSmoothScroll(buffer, ...args) {
	!document.scrollingElement && (document.scrollingElement = document.documentElement);
	!location.origin && (location.origin = `${location.protocol}//${location.hostname}`);
	
	$.data(this.get(0), {
		smoothScrollBuffer: u_.isInteger(buffer) ? buffer : 0,
		smoothScrollDuration: u_.isInteger(args[0]) ? args.shift() : 600,
		smoothScrollCallBack: args.pop(),
		smoothScroll(hash) {
			const $target = $(hash);
			!!$target.length && $(document.scrollingElement).animate({
				scrollTop: $target.offset().top - this.smoothScrollBuffer
			}, {
				complete: u_.isFunction(this.smoothScrollCallBack) ? () => {
					return this.smoothScrollCallBack($target);
				} : null,
				duration: this.smoothScrollDuration
			});
			return this;
		}
	});
	
	this.on("click", "a", e => {
		const elm = e.currentTarget;
		const data = $.data(e.delegateTarget);
		const checkStr = location.origin + location.pathname + elm.search;
		
		// ページ内リンクのクリック時のみ発火
		if(elm.hash && elm.href.replace(elm.hash, "") === checkStr) {
			e.preventDefault();
			data.smoothScroll(elm.hash);
		}
	});
	
	!!location.hash && setTimeout(() => $.data(this.get(0)).smoothScroll(location.hash), 0);
	
	return this;
};

